import { PassengerTypeEnum } from '@msc-b2c/interfaces/enums';
import { IBookingResponse } from '../../../../../../interfaces/src/lib/interfaces/index';

export const responsebookingsMock: IBookingResponse = {
  bookingNumber: 123456,
  optionExpirationDate: '2024-09-07T00:00:00+02:00',
  totalPaymentReceived: '271482629.0151',
  total: {
    afterDiscount: '9460876.8828',
    beforeDiscount: '6257596376',
    dueDate: '2024-10-30',
  },
  deposit: {
    afterDiscount: '669587692779',
    beforeDiscount: '4596609.26',
    dueDate: '2024-10-10',
  },
  passengers: [
    {
      number: 1,
      id: 123456,
      type: PassengerTypeEnum.ADULT,
      leadPassenger: true,
      age: 40,
    },
  ],
  bookingBreakdown: [
    {
      itemId: 223148193,
      type: 'CRU',
      code: 'GR20240907NAPNAP',
      categoryCode: 'SL1',
      cabinNumber: 10161,
      priceCode: 'VIC01939IT5012EA',
      passengers: [1, 2],
      startDate: '2024-09-07T00:00:00+02:00',
      endDateOffset: '2024-09-07T00:00:00+02:00',
      items: [
        {
          id: 12345,
          packageCode: 571896567,
          type: 'CRU',
          code: 'EXP2B',
          startDate: '2024-09-07T00:00:00+02:00',
          endDateOffset: '2024-09-07T00:00:00+02:00',
          passengers: [1, 2],
        },
      ],
    },
  ],
};
